module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-fr-FR.03ff39b9.jpg";